import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Box, Typography, CircularProgress, Card, CardContent, Stack } from '@mui/material';
import { useContent } from '../../../../context/ContentContext';

const ProductsDisplay = () => {
    const { categories, loading } = useContent();
    const [value, setValue] = useState(0);
    const [mounted, setMounted] = useState(false);

    console.log('Loading:', loading);
    console.log('Categories:', categories);

    useEffect(() => {
        if (!mounted) {
            setMounted(true); // Set mounted to true after first render
        }
    }, [mounted]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // Show loading spinner if data is being fetched
    if (loading || !mounted) {
        return <CircularProgress />;
    }

    // Handle case when categories are not yet available
    if (!categories || categories.length === 0) {
        return (
            <Stack
                sx={{ width: '100%', height: '100vh', justifyContent: 'center', alignItems: 'center' }}
                direction="column"
                spacing={2}
            >
                <Typography variant="h6">Tidak ada kategori yang tersedia</Typography>
                <img
                    src="/images/NoResultFound.webp"
                    alt="No categories found"
                    style={{ width: '300px', height: 'auto' }}
                />
            </Stack>
        );
    }

    return (
        <Card sx={{ width: '100%', margin: '20px 0' }}>
            <CardContent>
                <Box sx={{ width: '100%' }}>
                    {/* Tabs section */}
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        scrollButtons="auto"
                        variant="scrollable"
                        aria-label="category tabs"
                        sx={{ borderBottom: 1, borderColor: 'divider' }}
                    >
                        {categories.map((category, index) => (
                            <Tab key={category.id} label={category.name} />
                        ))}
                    </Tabs>

                    {/* Tab Panel section */}
                    {categories.map((category, index) => (
                        <TabPanel value={value} index={index} key={category.id}>
                            <iframe
                                src={category.url}
                                title={category.name}
                                style={{ width: '100%', height: '500px', border: 'none' }}
                            />
                        </TabPanel>
                    ))}
                </Box>
            </CardContent>
        </Card>
    );
};

// TabPanel Component to render content for each tab
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

export default ProductsDisplay;
